import { render, staticRenderFns } from "./SearchResultPostItem.vue?vue&type=template&id=1def45dd&scoped=true&"
import script from "./SearchResultPostItem.vue?vue&type=script&lang=js&"
export * from "./SearchResultPostItem.vue?vue&type=script&lang=js&"
import style0 from "./SearchResultPostItem.vue?vue&type=style&index=0&id=1def45dd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1def45dd",
  null
  
)

export default component.exports